var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3583_4677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49966 14.1665V17.4995H5.83365V14.1665H2.49966ZM14.1667 14.1665V17.4995H17.4997V14.1665H14.1667ZM8.33365 2.49951V5.8335H11.6667V2.49951H8.33365ZM13.3336 5.8335C13.3335 6.75382 12.587 7.49951 11.6667 7.49951H10.8336V9.1665H14.9997C15.4417 9.1665 15.8658 9.34222 16.1784 9.65479C16.4909 9.96735 16.6667 10.3915 16.6667 10.8335V12.4995H17.4997C18.4201 12.4995 19.1667 13.246 19.1667 14.1665V17.4995C19.1667 18.42 18.4201 19.1665 17.4997 19.1665H14.1667C13.2462 19.1665 12.4997 18.42 12.4997 17.4995V14.1665C12.4997 13.246 13.2462 12.4995 14.1667 12.4995H14.9997V10.8335H4.99966V12.4995H5.83365C6.75397 12.4997 7.49966 13.2461 7.49966 14.1665V17.4995C7.49966 18.4199 6.75397 19.1663 5.83365 19.1665H2.49966C1.57934 19.1663 0.833649 18.4199 0.833649 17.4995V14.1665C0.833649 13.2461 1.57934 12.4997 2.49966 12.4995H3.33365V10.8335C3.33365 10.3915 3.50937 9.96735 3.82193 9.65479C4.1344 9.3424 4.55783 9.16659 4.99966 9.1665H9.16666V7.49951H8.33365C7.41328 7.49951 6.66683 6.75382 6.66666 5.8335V2.49951C6.66683 1.57919 7.41328 0.833496 8.33365 0.833496H11.6667C12.587 0.833496 13.3335 1.57919 13.3336 2.49951V5.8335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3583_4677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.7221dd38c6d16e898c309dd41ce1ee20.svg";
export { ForwardRef as ReactComponent };